import { render, staticRenderFns } from "./insuranceVerificationTest.vue?vue&type=template&id=4af89ee7&scoped=true&"
import script from "./insuranceVerificationTest.vue?vue&type=script&lang=js&"
export * from "./insuranceVerificationTest.vue?vue&type=script&lang=js&"
import style0 from "./insuranceVerificationTest.vue?vue&type=style&index=0&id=4af89ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af89ee7",
  null
  
)

export default component.exports